var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5C11 8.53757 8.53757 11 5.5 11C2.46243 11 0 8.53757 0 5.5C0 2.46243 2.46243 0 5.5 0C8.53757 0 11 2.46243 11 5.5Z",
    fill: "#B60000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.75C5.64587 2.75 5.78576 2.80795 5.88891 2.91109C5.99205 3.01424 6.05 3.15413 6.05 3.3V6.05C6.05 6.19587 5.99205 6.33576 5.88891 6.43891C5.78576 6.54205 5.64587 6.6 5.5 6.6C5.35413 6.6 5.21424 6.54205 5.11109 6.43891C5.00795 6.33576 4.95 6.19587 4.95 6.05V3.3C4.95 3.15413 5.00795 3.01424 5.11109 2.91109C5.21424 2.80795 5.35413 2.75 5.5 2.75ZM5.5 8.25C5.35413 8.25 5.21424 8.19205 5.11109 8.08891C5.00795 7.98576 4.95 7.84587 4.95 7.7C4.95 7.55413 5.00795 7.41424 5.11109 7.31109C5.21424 7.20795 5.35413 7.15 5.5 7.15C5.64587 7.15 5.78576 7.20795 5.88891 7.31109C5.99205 7.41424 6.05 7.55413 6.05 7.7C6.05 7.84587 5.99205 7.98576 5.88891 8.08891C5.78576 8.19205 5.64587 8.25 5.5 8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.79bb1550e7be92efa80a26334a9a3863.svg";
export { ForwardRef as ReactComponent };